import { useFrame, useLoader } from '@react-three/fiber';
import { useRef } from 'react';
import { Group, SRGBColorSpace, TextureLoader } from 'three';

import CloudyScreen from '0_canvas/WeatherScreens/CloudyScreen/CloudyScreen';
import RainScreen from '0_canvas/WeatherScreens/RainScreen/RainScreen';
import SunScreen from '0_canvas/WeatherScreens/SunScreen/SunScreen';
import ThunderstormScreen from '0_canvas/WeatherScreens/ThunderstormScreen/ThunderstormScreen';
import { WEATHER_SCREEN_PREFIX } from '0_canvas/WeatherScreens/WeatherScreens.utils';
import WindyScreen from '0_canvas/WeatherScreens/WindyScreen/WindyScreen';
import { useResponseStore } from 'state/responseStore';
import { useThreeStore } from 'state/threeStore';

import useMatrixUpdateHandler from 'hooks/useMatrixUpdateHandler';

const WEATHER_SCREEN_VARIANTS = ['rainy', 'windy', 'sunny', 'cloudy', 'stormy'];

const WeatherScreenScene = ({ textureUrl }: { textureUrl: string }) => {
  const weatherSceneRef = useRef<Group>(null!);

  const [backgroundTexture] = useLoader(TextureLoader, [textureUrl]);
  backgroundTexture.colorSpace = SRGBColorSpace;
  backgroundTexture.flipY = false;

  useFrame(() => {
    const { isRendered } = useThreeStore.getState().weather;
    const stage = useResponseStore.getState().response.weather?.precisCode;
    weatherSceneRef.current.visible = isRendered;

    const currentWeather = stage;

    WEATHER_SCREEN_VARIANTS.forEach(suffix => {
      const screen = weatherSceneRef.current.getObjectByName(
        WEATHER_SCREEN_PREFIX + suffix
      );

      if (!screen) return;
      screen.visible = suffix === currentWeather;
    });
  });

  useMatrixUpdateHandler(
    () => useThreeStore.getState().weather.isRendered,
    weatherSceneRef.current
  );
  if (!backgroundTexture) return;

  return (
    <group ref={weatherSceneRef}>
      <WindyScreen
        position={[0, 0, -80]}
        backgroundTexture={backgroundTexture}
      />
      <RainScreen
        position={[0, 0, -80]}
        backgroundTexture={backgroundTexture}
      />
      <CloudyScreen
        position={[0, 0, -80]}
        backgroundTexture={backgroundTexture}
      />
      <ThunderstormScreen
        position={[0, 0, -80]}
        backgroundTexture={backgroundTexture}
      />
      <SunScreen position={[0, 0, -80]} backgroundTexture={backgroundTexture} />
    </group>
  );
};

export default WeatherScreenScene;
